<template>
  <base-modal
    :show="open"
    :title="title"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Add')"
    :closeText="$t('Close')"
  >
    <v-form class="mt-5">
      <v-select
        multiple
        v-model="selected"
        item-text="text"
        item-value="id"
        :items="list"
        v-bind:label="$t('SelectWidget')"
      ></v-select>
    </v-form>
  </base-modal>
</template>
<script>
import WidgetService from "@/services/WidgetService";
import WidgetType from "@/ecm/variables/WidgetType";
import Utils from "@/ecm/common/Utils";

export default {
  name: "WidgetAddModal",
  created() {
    WidgetService.getList().then((data) => {
      this.list = data
        .map((d) => {
          return { id: d.id, text: this.getWidgetName(parseInt(d.id)) };
        })
        .sort(Utils.text.compare("text"));
    });
  },
  data() {
    return {
      list: [],
      selected: [],
      title: this.$t("AddWidget"),
      open: false,
    };
  },
  methods: {
    saveItem() {
      this.open = false;
      this.$emit("on-widget-selected", this.selected);
    },
    show() {
      this.selected = [];
      this.open = true;
    },
    hide() {
      this.open = false;
    },
    getWidgetName(widgetId) {
      switch (widgetId) {
        case WidgetType.Baskets:
          return this.$t("Baskets");
        case WidgetType.UserSearches:
          return this.$t("SavedSearches");
        case WidgetType.Distributions:
          return this.$t("DistributionInternalExternal");
        case WidgetType.UploadedDocumentsChart:
          return this.$t("WidgetLoadedDocumentTitle");
        case WidgetType.DocumentsByContentTypeChart:
          return this.$t("WidgetDocumentsByContentTypeTitle");
        case WidgetType.DocumentsByWorkflowChart:
          return this.$t("WidgetDocumentsByWorkflowTitle");
        case WidgetType.Bookmark:
          return this.$t("WidgetBookmarkTitle");
        case WidgetType.Note:
          return this.$t("WidgetNoteTitle");
        case WidgetType.Card:
          return this.$t("WidgetCardTitle");
        case WidgetType.SearchHistory:
          return this.$t("WidgetSearchHistoryTitle");
        case WidgetType.Newsfeed:
          return this.$t("WidgetNewsfeedTitle");
        case WidgetType.DocumentTracker:
          return this.$t("WidgetDocumentTrackerTitle");
      }
    },
  },
};
</script>